
import React from 'react';
import { StoryWrapper } from '../StoryWrapper';
import styles from '../week-reflection.module.css';
import EnergyTrendLineChart from "../../insights/EnergyTrendLineChart";

const chartLineColor = '#C5EBD4';

export const EnergyLevels = ({ story, action, isPaused, config, storyData }) => {
    return (
        <StoryWrapper storyName={storyData.component} action={action} isPaused={isPaused}>
            <h1 className={styles.size2} style={{ marginBottom: "3rem" }}>What your energy levels looked like</h1>
            <div style={{ marginBottom: "3rem" }}>
                <EnergyTrendLineChart data={storyData.data.energyLevels} lineColor={chartLineColor} />
            </div>
        </StoryWrapper>
    );
};